import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { getBrowser } from '@/pwa/installContext';
import { InstallSteps } from '@/components/pwa/InstallSteps';

interface Props {
  open: boolean;
  onClose: () => void;
}

const LABEL = {
  'ios-safari': 'iPhone ou iPad (Safari)',
  'ios-other': 'iPhone ou iPad',
  android: 'Android',
  'in-app': 'navegador do WhatsApp/Instagram/Facebook',
  desktop: 'computador',
} as const;

/** Passo a passo para instalar o único aplicativo AutoFluxo. */
export function InstallGuideDialog({ open, onClose }: Props) {
  const browser = getBrowser();
  return (
    <Dialog open={open} onOpenChange={(nextOpen) => !nextOpen && onClose()}>
      <DialogContent className="max-w-sm z-[400]">
        <DialogHeader>
          <DialogTitle>Instalar AutoFluxo</DialogTitle>
          <DialogDescription>Passo a passo para {LABEL[browser]}.</DialogDescription>
        </DialogHeader>
        <InstallSteps browser={browser} />
      </DialogContent>
    </Dialog>
  );
}
